import { render, staticRenderFns } from "./UsersDeleted.vue?vue&type=template&id=e8a36c3a&"
import script from "./UsersDeleted.vue?vue&type=script&lang=js&"
export * from "./UsersDeleted.vue?vue&type=script&lang=js&"
import style0 from "./UsersDeleted.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports